export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12049.433a0619.jpg";